import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/marketing/Header';
import { Footer } from './components/marketing/ClosingSections';
import { MotionProvider } from './components/marketing/MotionProvider';
import { AppLink, TextLink } from './components/marketing/Primitives';
import { site } from './config/site';
import Home from './pages/Home';
import './App.css';
import './styles/readability.css';

const Whitepaper = lazy(() => import('./pages/Whitepaper'));

const Metadata = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const paper = pathname === '/whitepaper';
    const title = paper ? 'White Paper | Cortis' : site.title;
    const description = paper ? 'Explore the architecture behind Cortis: identity, private memory, specialist agents, and verifiable records of work.' : site.description;
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', site.origin + (paper ? '/whitepaper' : ''));
    ['og:title', 'twitter:title'].forEach(name => document.querySelector(`meta[property="${name}"], meta[name="${name}"]`)?.setAttribute('content', title));
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', site.origin + (paper ? '/whitepaper' : ''));
    ['og:description', 'twitter:description'].forEach(name => document.querySelector(`meta[property="${name}"], meta[name="${name}"]`)?.setAttribute('content', description));
  }, [pathname]);
  return null;
};

export const NotFound = () => <main id="main-content" tabIndex={-1} className="document-state container" data-testid="not-found-page"><span className="eyebrow">Cortis / 404</span><h1 data-testid="not-found-title">A different direction.</h1><p data-testid="not-found-description">This page could not be found. Your operator is one step away.</p><div className="button-row"><TextLink href="/" testId="not-found-home">Back to Cortis</TextLink><AppLink location="not-found" /></div></main>;

function App() {
  return <BrowserRouter><MotionProvider><Metadata /><Header /><Suspense fallback={<main id="main-content" className="document-loading container" data-testid="document-loading" aria-live="polite">Opening the white paper…</main>}><Routes><Route path="/" element={<Home />} /><Route path="/whitepaper" element={<Whitepaper />} /><Route path="*" element={<NotFound />} /></Routes></Suspense><Footer /></MotionProvider></BrowserRouter>;
}
export default App;